<template>
	<div style="padding: 0 10px">
		<el-card v-loading="isContentLoading" style="min-height: 1000px">
			<insure-info-detail-custom
				ref="refInsureInfoDetail"
				:insure-type="insureType"
				:is-loading="isLoading"
				:pub-detail="tempDetail"
				:pub-info="tempPubInfo"
				@onDetailDeal="onDetailDeal"
				@onDetailSearch="onDetailSearch"></insure-info-detail-custom>
		</el-card>
		<insure-notices ref="refShowNotices" @onToInsure="onAgreeInsure"></insure-notices>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {detailSearch, getInsureProfile} from 'meibao-insure/src/api/productCenterNew'

import {InsureInfoDetailCustom, InsureNotices} from 'meibao-insure'
import {currentYYYYmmdd} from '@/util/date'
import {handleDownCategoryFile} from '@/util/util'
import rrlog from '@meibao/traceback-record'
import {getPageId} from '@/util/commonUtils'
import {setStore} from '@/util/store'
import {isJiaDian} from 'meibao-insure/src/util/productUtil'
import {toInsureCenter} from '@/util/insureUtils'

export default {
	name: 'detailsCenter',
	mixins: [],
	components: {InsureInfoDetailCustom, InsureNotices},
	props: {},
	data() {
		return {
			isContentLoading: true,
			isLoading: false,
			insureType: -1,
			productId: -1,
			tempPubInfo: {},
			tempDetail: {},
			productIdCenter: '',
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])=1&=807
		getModeIds() {
			let {productId, productIdCenter = '', mode, pubPkgId} = this.$route.query
			return {sourceProductId: productId, productId: productIdCenter, mode, pubPkgId}
		},
	},
	watch: {},
	created() {
		//请求产品详情
		this.insureType = this.$route.params.insureType
		let {productId, productIdCenter = ''} = this.$route.query
		this.productId = productId
		this.productIdCenter = productIdCenter
		this.getProductDetails()
	},
	mounted() {},
	methods: {
		async getProductDetails() {
			try {
				let result = (await getInsureProfile(Object.assign({settingSign: 2}, this.getModeIds))) || {}
				let {code, data = {}, msg = '异常错误！'} = result.data
				if (code === 0) {
					let {pubInfo, detail, productType = ''} = data
					this.tempPubInfo = pubInfo
					this.tempDetail = detail
					this.insureType = productType
				} else {
					this.$message.error(msg)
				}
			} catch (e) {
			} finally {
				this.isContentLoading = false
			}
		},
		//1 投保提醒，2计划书，3 下载职业类别
		onDetailDeal(type) {
			switch (type) {
				case 1:
					this.rrlogEventId = rrlog.capture(
						`去投保`,
						{
							productId: this.productId,
						},
						{
							sign: true,
						},
					)
					this.onShowHint()
					break
				case 2:
					//计划书
					if (isJiaDian(this.insureType)) {
						this.$message.error('该产品计划书紧急开发中..')
						return
					}
					this.$router.push({
						path: this.$router.$avueRouter.getPath({
							src: `/plan/planInsure`,
						}),
						query: {
							productId: this.productId,
							insureType: this.insureType,
							productIdCenter: this.productIdCenter,
						},
					})
					break
				case 3:
					//下载
					this.isLoading = true
					let fileName = `fgk_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
					handleDownCategoryFile(
						`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
						{},
						fileName,
					)
						.then(() => {
							//下载成功
						})
						.catch(() => {})
						.finally(() => {
							this.isLoading = false
						})
					break
			}
		},
		onAgreeInsure() {
			//去投保
			let pageId = getPageId()
			if (this.rrlogEventId) {
				setStore({name: `rrlog_eventid_${pageId}`, content: this.rrlogEventId, type: 'session'})
			}
			//跳转投保页
			toInsureCenter(
				Object.assign(
					{
						act: `new`,
						pageId: pageId,
						insureType: this.insureType,
					},
					this.getModeIds,
				),
			)
		},
		async onShowHint() {
			this.isLoading = true
			await this.$refs.refShowNotices.onGetHintInfoData(this.getModeIds)
			this.isLoading = false
			// try {
			//   this.isLoading = true
			//   let tempData = await getInsureHint(this.getModeIds)
			//   let {code = -1, data, msg} = tempData.data || {}
			//   if (code === 0) {
			//     let {hintInfo = {}} = data
			//     this.$refs.refShowNotices.onShowNotices(hintInfo)
			//   } else {
			//     this.$message.error(msg)
			//   }
			// } catch (e) { } finally {
			//   this.isLoading = false
			// }
		},
		//搜索回调
		onDetailSearch(params) {
			this.isContentLoading = true
			//请求数据
			let requestData = Object.assign(params, this.getModeIds)
			detailSearch(requestData)
				.then((response) => {
					let {code = -1, data = {}} = response.data || {}
					if (code === 0) {
						//设置详情
						this.$refs.refInsureInfoDetail.setSearchData(data)
					}
				})
				.catch(() => {})
				.finally(() => {
					this.isContentLoading = false
				})
		},
		//链接校验
		onCheckNum() {
			this.$prompt('', '提示', {
				inputPlaceholder: '请大声喊芝麻开门！',
				inputErrorMessage: '声音有点小了！',
				showCancelButton: false,
				showClose: false,
				confirmButtonText: '芝麻开门',
				closeOnClickModal: false,
				closeOnPressEscape: false,
				inputValidator: (value) => {
					return value === 'meibao'
				},
			}).then((res) => {
				console.log(res, '----123')
			})
		},
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped></style>
